module.exports = __webpack_public_path__ + "static/media/Logo_NoBackground_red2.bc147b30.png";